import { render } from "./ReceivesMailingModel.vue?vue&type=template&id=0c588f41&scoped=true"
import script from "./ReceivesMailingModel.vue?vue&type=script&lang=js"
export * from "./ReceivesMailingModel.vue?vue&type=script&lang=js"

import "./ReceivesMailingModel.vue?vue&type=style&index=0&id=0c588f41&lang=scss"
import "./ReceivesMailingModel.vue?vue&type=style&index=1&id=0c588f41&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c588f41"]])

export default __exports__